/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PartnerIntent } from "./PartnerIntent";

/**
 * Partner intent data for requests (without timestamp)
 */
export interface PartnerIntentRequest {
  /** The partner identifier */
  partner: PartnerIntent;
  /** External ID */
  external_id?: string | null;
}
